<template>
    <div aria-live="assertive" class="pointer-events-none fixed inset-0 flex items-end px-4 py-6 sm:items-start sm:p-6 z-500 top-20">
        <div class="flex w-full flex-col items-center space-y-4 sm:items-end">
            <transition
                v-for="(alert, index) in alerts"
                :key="`${index}-alert-${alert.id}`"
                enter-active-class="transform ease-out duration-300 transition"
                enter-from-class="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
                enter-to-class="translate-y-0 opacity-100 sm:translate-x-0"
                leave-active-class="transition ease-in duration-100"
                leave-from-class="opacity-100"
                leave-to-class="opacity-0">
                <div class="pointer-events-auto w-full max-w-sm overflow-hidden rounded-lg bg-white ring-1 shadow-lg ring-black/5">
                    <div class="p-4">
                        <div class="flex items-start">
                            <div class="shrink-0">
                                <CheckCircleIcon v-if="alert.type === alertTypes.success" class="size-6 text-green-400" aria-hidden="true" />
                                <XCircleIcon v-if="alert.type === alertTypes.error" class="size-6 text-red-400"  aria-hidden="true" />
                                <ExclamationTriangleIcon v-if="alert.type === alertTypes.warning" class="size-5 text-yellow-400" aria-hidden="true" />
                                <InformationCircleIcon v-if="alert.type === alertTypes.info" class="size-6 text-blue-400" aria-hidden="true" />
                            </div>
                            <div class="ml-3 w-0 flex-1 pt-0.5">
                                <p class="text-sm font-medium text-gray-900">{{ alert.message }}</p>
<!--                                <p class="mt-1 text-sm text-gray-500">{{ alert.message }}</p>-->
                            </div>
                            <div class="ml-4 flex shrink-0">
                                <button type="button" @click="hideAlert(alert)" class="inline-flex rounded-md bg-white text-gray-400 hover:text-gray-500 focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 focus:outline-hidden">
                                    <span class="sr-only">Close</span>
                                    <XMarkIcon class="size-5" aria-hidden="true" />
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </transition>
        </div>
    </div>
</template>

<script lang="ts">
import {defineComponent} from "vue";
import {mapActions, mapGetters} from "vuex";
import {AlertType} from "@/types";
import {Alert} from "@/types/AlertType";

import {
    CheckCircleIcon,
    XCircleIcon,
    ExclamationTriangleIcon,
    InformationCircleIcon
} from '@heroicons/vue/24/outline'
import { XMarkIcon } from '@heroicons/vue/20/solid'

export default defineComponent({
    name: "AlertsComponent",

    components: {
        CheckCircleIcon,
        XCircleIcon,
        ExclamationTriangleIcon,
        InformationCircleIcon,
        XMarkIcon
    },

    computed: {
        ...mapGetters({
            alerts: "alerts/alerts",
        }),

        alertTypes(): typeof AlertType {
            return AlertType;
        }
    },

    methods: {
        ...mapActions({
            remove: "alerts/remove"
        }),

        hideAlert(alert: Alert) {
            this.remove({id: alert.id});
        }
    }
})
</script>